define( [
	"./arr"
], function( arr ) {
	return arr.indexOf;
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/var/indexOf.js
 ** module id = 817
 ** module chunks = 2
 **/